export const SET_SERVICE_LIST = 'SET_SERVICE_LIST'
// export const SET_BACKUP_MANAGER_INFO = 'SET_BACKUP_MANAGER_INFO';
// export const SET_SELECTED_MANAGER_INFO = 'SET_SELECTED_MANAGER_INFO';
// export const SET_SELECTED_MANAGER_DEPARTMENT = 'SET_SELECTED_MANAGER_DEPARTMENT';
// export const SET_SELECTED_MANAGER_EMAIL = 'SET_SELECTED_MANAGER_EMAIL';
// export const SET_SELECTED_MANAGER_NOTE = 'SET_SELECTED_MANAGER_NOTE';
// export const SET_SELECTED_MANAGER_PHONE = 'SET_SELECTED_MANAGER_PHONE';
// export const SET_SELECTED_MANAGER_POSITION_ID = 'SET_SELECTED_MANAGER_POSITION_ID';
// export const SET_SELECTED_MANAGER_NUMBER = 'SET_SELECTED_MANAGER_NUMBER';



// WEBPACK FOOTER //
// ./src/store/serviceStore/mutation-types.js